// Messaging roles, in one place. The backend's organizations/messaging_constants.py
// is the source of truth for the values; the labels live in the MessageListView
// namespace so every portal renders the same words.

export const ROLE_FLEET_MANAGER = 'fleet_manager';
export const ROLE_DRIVER = 'driver';
// Ajoneuvovastaava: grantable like the others AND assignable per vehicle.
export const ROLE_VEHICLE_MANAGER = 'vehicle_manager';
// Recipient-row target only (never grantable): the ajoneuvovastaava(s) of the
// message's linked vehicles.
export const ROLE_ASSIGNED_VEHICLE_MANAGER = 'assigned_vehicle_manager';
export const ROLE_WORKSHOP_CONTACT = 'workshop_contact';
export const ROLE_CHAIN_CONTACT = 'chain_contact';

const NS = { ns: 'MessageListView' };

const LABEL_KEYS = {
  fleet_manager: 'fleetManager',
  driver: 'driver',
  vehicle_manager: 'vehicleManager',
  assigned_vehicle_manager: 'assignedVehicleManager',
  workshop_contact: 'workshopContact',
  chain_contact: 'chainContact',
};

export function getMessagingRoleLabel(t, role) {
  if (!role) return t('allRecipients', NS);
  const key = LABEL_KEYS[role];
  return key ? t(key, NS) : role;
}

// Roles an organization user can be granted (Permissions page MultiSelect).
export function getOrganizationGrantableRoleOptions(t) {
  return [
    { label: t('fleetManager', NS), value: ROLE_FLEET_MANAGER },
    { label: t('vehicleManager', NS), value: ROLE_VEHICLE_MANAGER },
    { label: t('driver', NS), value: ROLE_DRIVER },
  ];
}

// Targets an organization recipient row can be narrowed to in the compose dialog.
// "The vehicle's ajoneuvovastaava" only makes sense when the message is about vehicles.
export function getOrganizationRecipientRoleOptions(t, hasVehicles) {
  const options = [{ label: t('allRecipients', NS), value: '' }];
  if (hasVehicles) {
    options.push({ label: t('assignedVehicleManager', NS), value: ROLE_ASSIGNED_VEHICLE_MANAGER });
  }
  options.push({ label: t('recipientAllVehicleManagers', NS), value: ROLE_VEHICLE_MANAGER });
  options.push({ label: t('fleetManager', NS), value: ROLE_FLEET_MANAGER });
  options.push({ label: t('driver', NS), value: ROLE_DRIVER });
  return options;
}

export function getWorkshopRecipientRoleOptions(t) {
  return [
    { label: t('allRecipients', NS), value: '' },
    { label: t('workshopContact', NS), value: ROLE_WORKSHOP_CONTACT },
  ];
}

// A copy of recipient_roles without the vehicle-bound target — used when the
// message stops being about vehicles.
export function stripAssignedVehicleManager(recipientRoles) {
  if (!recipientRoles || !recipientRoles.organizations) return recipientRoles;
  const organizations = {};
  Object.keys(recipientRoles.organizations).forEach((key) => {
    if (recipientRoles.organizations[key] !== ROLE_ASSIGNED_VEHICLE_MANAGER) {
      organizations[key] = recipientRoles.organizations[key];
    }
  });
  return { ...recipientRoles, organizations };
}
